import './applied_filter_view.js.coffee';# Added by Script 
Namespace 'Monitoring.Views.SocialContents.Filters'

class Monitoring.Views.SocialContents.Filters.AppliedGmbProvincesFilterView extends
      Monitoring.Views.SocialContents.Filters.AppliedFilterView
  name: 'gmb_provinces'
  humanize: true
  unmodifiableByModerators: false

  initialize: ({searchQuery}) ->
    super({searchQuery: searchQuery})
    @alias = I18n.t('monitoring.dashboard.filters.gmb_provinces')

  removeFilter: (value) ->
    @searchQuery.removeGmbProvince(value)

  getDescription: (province) ->
    super(province)
